import { Check } from "lucide-react";

function FearSymptoms({ signs }) {
  return (
    <section className="glass-panel rounded-lg p-6">
      <h2 className="font-display text-3xl text-museum-bone">Common signs</h2>
      <ul className="mt-5 grid gap-3 sm:grid-cols-2">
        {signs.map((sign) => (
          <li key={sign} className="flex items-center gap-3 text-sm capitalize text-museum-muted">
            <span className="flex h-6 w-6 items-center justify-center rounded-full border border-museum-gold/30 text-museum-gold">
              <Check size={14} aria-hidden="true" />
            </span>
            {sign}
          </li>
        ))}
      </ul>
    </section>
  );
}

export default FearSymptoms;
